import React from 'react';
import { FadeIn } from './FadeIn';
import { Layers } from 'lucide-react';
export function SolutionOverview() {
  return <section className="pt-4 pb-2 px-3 max-w-3xl mx-auto" data-id="element-218">
      <FadeIn className="text-center mb-4" data-id="element-219">
        <div className="inline-flex items-center gap-2.5 px-5 py-2 rounded-full border border-accent/30 bg-accent/5 mb-2 whitespace-nowrap" data-id="element-220">
          <Layers size={18} className="text-accent" data-id="element-221" />
          <h2 className="font-display text-sm md:text-base font-bold text-accent" data-id="element-222">
            Sistema integral para profesionales
          </h2>
        </div>
      </FadeIn>
    </section>;
}